"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTimecard_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Location_1 = require("./Location");
var UserTimecardOverride_1 = require("./UserTimecardOverride");
var UserTimecard_Factory = /** @class */ (function () {
    function UserTimecard_Factory() {
    }
    UserTimecard_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ClockIn: Date_Factory_1.Date_Factory.CreateIncoming(model.ClockIn),
            ClockOut: Date_Factory_1.Date_Factory.CreateIncoming(model.ClockOut),
            IPIn: model.IPIn,
            IPOut: model.IPOut,
            PracticeLocation: Location_1.Location_Factory.CreateIncoming(model.PracticeLocation),
            PracticeLocationId: model.PracticeLocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            UserTimecardOverrides: model.UserTimecardOverrides && model.UserTimecardOverrides.map(function (i) { return UserTimecardOverride_1.UserTimecardOverride_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    UserTimecard_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ClockIn: Date_Factory_1.Date_Factory.CreateOutgoing(model.ClockIn),
            ClockOut: Date_Factory_1.Date_Factory.CreateOutgoing(model.ClockOut),
            IPIn: model.IPIn,
            IPOut: model.IPOut,
            PracticeLocation: Location_1.Location_Factory.CreateOutgoing(model.PracticeLocation),
            PracticeLocationId: model.PracticeLocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            UserTimecardOverrides: model.UserTimecardOverrides && model.UserTimecardOverrides.map(function (i) { return UserTimecardOverride_1.UserTimecardOverride_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return UserTimecard_Factory;
}());
exports.UserTimecard_Factory = UserTimecard_Factory;
